module.exports = __webpack_public_path__ + "img/skills.a4c19c35.svg";